/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendRestorePasswordDto } from '../../models/backend-restore-password-dto';
import { BackendRestorePasswordRequestDto } from '../../models/backend-restore-password-request-dto';

export interface AccountMeRestorePasswordCreate$FormData$Params {
  body: BackendRestorePasswordRequestDto;
}

export function accountMeRestorePasswordCreate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: AccountMeRestorePasswordCreate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendRestorePasswordDto>> {
  const rb = new RequestBuilder(rootUrl, accountMeRestorePasswordCreate$FormData.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendRestorePasswordDto>;
    }),
  );
}

accountMeRestorePasswordCreate$FormData.PATH = '/api/account/me/restore_password/';
